import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import moment from "moment";

import { getEmailHistoryByLeadId } from "../../actionCreator/leadDetailsActionCreator";
import EmailAttachment from "./EmailAttachment";
import Loader from "../loader";
import HtmlRenderer from "./HtmlRenderer";
import EmailCard from "./EmailCard";

const EmailHistory = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [viewEmail, setViewEmail] = useState();
  const loading = useSelector((state) => state.LeadDetailsReducer.loading);
  const emailConversationHistory = useSelector(
    (state) => state.LeadDetailsReducer.emailConversationHistory
  );
  const leadDetail = useSelector(
    (state) => state.LeadDetailsReducer.leadDetails
  );

  useEffect(() => {
    dispatch(getEmailHistoryByLeadId(id));
  }, [id, dispatch]);

  if (loading) {
    return <Loader />;
  }

  const normalizeSubject = (subject = "") => {
    return subject
      .replace(/^(re:|fw:|fwd:)\s*/gi, "")
      .trim()
      .toLowerCase();
  };
  
  const formatEmailsByThread = (emails) => {
    const grouped = {};
  
    emails.forEach((email) => {
      const key = email.threadId
        ? email.threadId
        : normalizeSubject(email.subject) || "no-subject";
  
      if (!grouped[key]) {
        grouped[key] = [];
      }
  
      grouped[key].push(email);
    });
  
    const formattedArray = Object.entries(grouped).map(([groupKey, groupEmails]) => {
      const sortedEmails = groupEmails.sort(
        (a, b) => new Date(a.createdDate) - new Date(b.createdDate)
      );
  
      return {
        groupKey,
        emails: sortedEmails,
      };
    });
  
    return formattedArray;
  };

  const formattedEmails = formatEmailsByThread(emailConversationHistory);

  return (
    <div className="email-history p-20">
      <h3 className="heading24px fw-semibold text-color-1C1C1C">History</h3>
      <Row>
        <Col xs={!!viewEmail ? 0 : 24}>
          <div className="emails-list">
            <div className="d-flex flex-column mt20" style={{ gap: 40 }}>
              {formattedEmails?.map((item, i) => (
                <React.Fragment key={i}>
                  {item?.emails?.map((data, index) => (
                    <EmailCard
                      key={index}
                      leadDetail={leadDetail}
                      setViewEmail={setViewEmail}
                      data={data}
                      id={id}
                      received={index !== 0}
                    />
                  ))}
                </React.Fragment>
              ))}
              {!emailConversationHistory?.length && (
                <span>There is no email conversation history found.</span>
              )}
            </div>
          </div>
        </Col>
        {!!viewEmail && (
          <Col className="d-flex flex-column email-details" xs={24}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex flex-column">
                <span className="heading18px fw-semibold mt20">
                  {viewEmail?.subject}
                </span>
                <span className="heading13px mt10">
                  From {viewEmail?.sender} to{" "}
                  {viewEmail?.recipients?.map((d) => d.recipientEmail)} on{" "}
                  {moment(viewEmail?.createdDate).format("MMMM DD, YYYY")}
                </span>
              </div>
              <CloseOutlined
                className="d-flex justify-content-end cursor-pointer mx-2"
                onClick={() => setViewEmail()}
              />
            </div>
            <div className="d-flex align-items-center flex-wrap fw-medium mt30">
              {!!viewEmail?.attachments?.length &&
                viewEmail?.attachments?.map((d, i) => (
                  <EmailAttachment key={i} attachment={d} />
                ))}
            </div>
            <span className="mt30">
              <HtmlRenderer
                fileUrl={viewEmail?.bodyS3Url}
                attachments={viewEmail?.attachments}
              />
            </span>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default EmailHistory;
